import ListSearchController from '../support/list_search_controller'

// Client-side name filter for the skills list (also used by the templates list).
// The list is fully server-rendered, so filtering is a show/hide pass over rows
// already in the DOM — each row carries its downcased name in data-name.
export default class extends ListSearchController {}
